// Angular
import { DOCUMENT } from '@angular/common';
import { ApplicationRef, createComponent, Inject, Injectable, Injector, TemplateRef, Type } from '@angular/core';
// Components
import { ModalComponent } from '../components/modal';
// Models
import { Overlay } from '../models';

@Injectable()
export class OverlayService {

  constructor(private applicationRef: ApplicationRef, @Inject(DOCUMENT) private document: Document) {
  }

  public createFromTemplate(templateRef: TemplateRef<HTMLElement>): Overlay<ModalComponent> {
    const overlay = new Overlay<ModalComponent>();
    const environmentInjector = this.applicationRef.injector;
    const elementInjector = Injector.create({ providers: [{ provide: Overlay, useValue: overlay }] });
    const componentRef = createComponent(ModalComponent, { environmentInjector, elementInjector });

    overlay.instance = componentRef.instance;
    overlay.instance.templateRef = templateRef;

    overlay.onPresent.subscribe(() => {
      this.applicationRef.attachView(componentRef.hostView);
      this.document.body.appendChild(componentRef.location.nativeElement);
    });

    overlay.onDismiss.subscribe({
      next: () => {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
      }
    });

    return overlay;
  }

  public create<T>(component: Type<T>): Overlay<T> {
    const overlay = new Overlay<T>();
    const environmentInjector = this.applicationRef.injector;
    const elementInjector = Injector.create({ providers: [{ provide: Overlay, useValue: overlay }] });
    const componentRef = createComponent(component, { environmentInjector, elementInjector });

    overlay.instance = componentRef.instance;

    overlay.onPresent.subscribe({
      next: () => {
        this.applicationRef.attachView(componentRef.hostView);
        this.document.body.appendChild(componentRef.location.nativeElement);
      }
    });

    overlay.onDismiss.subscribe({
      next: () => {
        this.applicationRef.detachView(componentRef.hostView);
        componentRef.destroy();
      }
    });

    return overlay;
  }
}
